import axios  from 'axios';

/**
 *
 * @returns {Promise<*>}
 */
const get = async () =>{
    const response = await axios.get('/reservations/vue/resources/config');
    return response.data.data;
}

export default get;
